export const outreachFormDataToPayload = (outreach) => {
  if (!outreach) return;
  const {
    title,
    collaborators,
    trackClicks,
    trackOpens,
    time_zone,
    schedule,
    atsJobId,
    interested_ats_job_stage_id,
    not_interested_ats_rejection_reason_id,
    tags,
    onStepFail,
    onStepFailForEmail,
    unsubscribeLink,
  } = outreach;
  const params = {
    title,
    track_clicks: trackClicks,
    track_opens: trackOpens,
    time_zone: time_zone,
    schedule,
    input_collaborators: collaborators?.map(({ id }) => id),
    tag_names: tags?.map((tag) => tag?.value),
    unsubscribe_link: unsubscribeLink,
  };
  if (atsJobId) {
    params['ats_job_id'] = atsJobId?.value;
  }
  if (interested_ats_job_stage_id) {
    params['interested_ats_job_stage_id'] = interested_ats_job_stage_id?.id;
  }
  if (not_interested_ats_rejection_reason_id) {
    params['not_interested_ats_rejection_reason_id'] =
      not_interested_ats_rejection_reason_id?.id;
  }
  if (onStepFail) {
    params['on_step_fail'] = onStepFail;
  }
  if (onStepFailForEmail) {
    params['on_step_fail_for_email'] = onStepFailForEmail;
  }

  return params;
};
